import { Alert as BannerMantine } from '@mantine/core'
import styled, { keyframes } from 'styled-components'

const slideDown = keyframes`
  from {
    transform: translateY(-20%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

export const Banner = styled(BannerMantine)`
  background-color: ${({ backGround }) => `${backGround}`} !important;
  animation: ${slideDown} 0.3s ease-in-out;

  .mantine-Alert-title {
    color: ${({ fontColor }) => fontColor} !important;
    font-size: 18px;
    font-family: Roboto;
  }

  .mantine-Alert-message {
    color: ${({ fontColor }) => fontColor} !important;
    font-size: 16px;
    font-family: Roboto;
  }
`
